import React from 'react';
import PropTypes from 'prop-types';
import {
  Spacer,
  ValidatedTextInputV2,
  Visible,
} from '@tfecom-thermofisher/react-komodo-design';

import { Message } from 'src/core/components';
import {
  ALIQUOTS_CHECKED,
  ALIQUOTS_NUMBER,
  ALIQUOTS_VOLUME,
  ALIQUOTS_NUMBER_MIN_VALUE,
  ALIQUOTS_VOLUME_MIN_VALUE,
  ALIQUOTS_NUMBER_MAX_VALUE,
  MORE_INFO_ALIQUOTS_LINK
} from 'src/constants/forms';
import { SectionTitle, Toggle } from 'src/components';
import {
  minNumberValidator,
  maxNumberValidator,
  nonEmptyValidator,
  numberOnlyValidator,
} from 'src/validators';
import messages from './messages';
import './Aliquots.style.scss';

const AliquotsComponent = ({ formData, onChangeData, showAliquotsCommonErr, maxValue }) => {
  const aliquotsVisible = formData[ALIQUOTS_CHECKED]?.value || false;

  return (
    <div>
      <SectionTitle title={messages.aliquots} allFieldsRequired />
      <Spacer bottom="22" />

      <Toggle
        {...{
          title: messages.aliquots,
          checked: aliquotsVisible,
          onToggle: (checked) => onChangeData(checked, ALIQUOTS_CHECKED, true),
          moreInfoLinkAliquots: MORE_INFO_ALIQUOTS_LINK,
        }}
      />

      <Visible when={aliquotsVisible}>
        <Spacer top="32" />
        <div className="aliquots__number_volume">
          <ValidatedTextInputV2
            data-testid="aliquots-number"
            label={<Message message={messages.numerOfAliquots} />}
            required
            initialValidation={!!formData[ALIQUOTS_NUMBER]?.value}
            validators={[
              nonEmptyValidator(messages.emptyNormalizationAliquotsNumberError),
              numberOnlyValidator(
                messages.numericalNormalizationALiqtuosNumberError
              ),
              minNumberValidator(
                ALIQUOTS_NUMBER_MIN_VALUE,
                messages.minNrNormalizationAliquotsError
              ),
              maxNumberValidator(
                ALIQUOTS_NUMBER_MAX_VALUE,
                messages.maxNrNormalizationAliquotsError
              )
            ]}
            showOnlyOneError
            value={formData[ALIQUOTS_NUMBER]?.value}
            onChange={
              (value, e, canValidate, isValid) => onChangeData(value, ALIQUOTS_NUMBER, isValid)
            }
          />
          <ValidatedTextInputV2
            data-testid="aliquots-volume"
            label={<Message message={messages.aliquotVolume} />}
            required
            initialValidation={!!formData[ALIQUOTS_VOLUME]?.value}
            validators={[
              nonEmptyValidator(
                messages.emptyNormalizationAliquotsVolumeInputError
              ),
              numberOnlyValidator(
                messages.noNrNormalizationAliquotsVolumeError
              ),
              minNumberValidator(
                ALIQUOTS_VOLUME_MIN_VALUE,
                messages.minNrNormalizationAliquotsVolumeError
              )
            ]}
            showOnlyOneError
            value={formData[ALIQUOTS_VOLUME]?.value}
            onChange={
              (value, e, canValidate, isValid) => onChangeData(value, ALIQUOTS_VOLUME, isValid)
            }
          />
        </div>
      </Visible>
      <Visible when={showAliquotsCommonErr}>
        <p className="alert-color">
          <Message
            message={{ ...messages.aliquotsMaxVolumeError, values: { maximumQuantity: maxValue } }}
          />
        </p>
      </Visible>
    </div>
  );
};

AliquotsComponent.propTypes = {
  formData: PropTypes.object,
  onChangeData: PropTypes.func.isRequired,
  showAliquotsCommonErr: PropTypes.bool,
  maxValue: PropTypes.any
};

export default AliquotsComponent;
